import React, { useContext } from "react";
import { Loader } from "../constents/components";
import useFetchProfile from "../Hooks/Registration/useFetchProfile";
import { useSelector } from "react-redux";
import ProfileComponent from "../Components/Profile/ProfieComponent";
import { ShowProfileContext } from "../Contexts/showProfileContext";

const SettingSection = () => {
    const {
        profileApplyFlow,
        missingFields,
        onProfileCompleted,
    } = useContext(ShowProfileContext);

    const Input = ({
        isEditable = false,
        change = () => {},
        value = "",
        type = "text",
        placeholder = "",
    }) => {
        return (
            <input
                type={type}
                value={value}
                className="w-full bg-transparent outline-none border-none"
                onChange={(e) => change(e.target.value)}
                disabled={!isEditable}
                placeholder={placeholder}
            />
        );
    };

    const [loading, error] = useFetchProfile();

    const user = useSelector((state) => state?.user);

    return (
        <div className="fixed top-0 right-0 left-0 bottom-0 flex items-center justify-center p-4 lg:p-8 bg-popup-bg-color backdrop-blur-[2px] z-[--after-registration-popup]">
            <div className="border bg-white w-full md:w-4/5 lg:w-2/5 rounded-xl flex flex-col items-center pt-8 min-h-[90vh] max-h-full overflow-auto">
                {loading ? (
                    <Loader />
                ) : error ? (
                    <></>
                ) : (
                    <ProfileComponent
                        user={user}
                        Input={Input}
                        profileApplyFlow={profileApplyFlow}
                        missingFields={missingFields}
                        onProfileCompleted={onProfileCompleted}
                    />
                )}
            </div>
        </div>
    );
};

export default SettingSection;